import React from 'react';
import { Alert, Link as MuiLink } from '@mui/material';
import { PersonAddAlt } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type GuestRelationshipBannerProps = {
  guestOrderId?: string;
  memberOrderId?: string;
};

export const GuestRelationshipBanner = ({ guestOrderId, memberOrderId }: GuestRelationshipBannerProps) => {
  const { t } = useTranslation();
  if (memberOrderId) {
    return (
      <Alert icon={<PersonAddAlt fontSize="inherit" />} severity="info">
        {t('calendar.edit_order.guest_of_member')}{' '}
        <MuiLink component={Link} to={`/dashboard/calendar?entityid=${memberOrderId}`}>
          {t('calendar.edit_order.view_member_booking')}
        </MuiLink>
      </Alert>
    );
  }
  if (guestOrderId) {
    return (
      <Alert icon={<PersonAddAlt fontSize="inherit" />} severity="info">
        {t('calendar.edit_order.brought_guest')}{' '}
        <MuiLink component={Link} to={`/dashboard/calendar?entityid=${guestOrderId}`}>
          {t('calendar.edit_order.view_guest_booking')}
        </MuiLink>
      </Alert>
    );
  }
  return null;
};
